export const COMPANY = {
  name: "PRPO LTD",
  activity: "Specialised Design Activities",
  sic: "74100 – Specialised Design Activities",
  email: "Premponnala42@gmail.com",
  phone: "07747425513",
  phoneHref: "tel:+447747425513",
  addressLines: ["Flat 8, Fenton Crescent", "Measham", "Swadlincote", "DE12 7EU", "United Kingdom"],
  description:
    "PRPO LTD is a UK-based creative design company specialising in graphic design, branding, visual identity, packaging and web and digital design.",
};

export const NAV = [
  { to: "/", label: "Home", testid: "home" },
  { to: "/services", label: "Services", testid: "services" },
  { to: "/portfolio", label: "Portfolio", testid: "portfolio" },
  { to: "/about", label: "About Us", testid: "about" },
  { to: "/contact", label: "Contact", testid: "contact" },
];

export const LEGAL = [
  { to: "/privacy-policy", label: "Privacy Policy", testid: "privacy" },
  { to: "/terms-and-conditions", label: "Terms and Conditions", testid: "terms" },
];

export const PROCESS = [
  {
    n: "01",
    title: "Discover",
    text: "Understand the client’s business, audience, goals, requirements, and creative direction.",
  },
  {
    n: "02",
    title: "Design",
    text: "Develop creative concepts, explore visual possibilities, and refine the selected direction according to the project requirements.",
  },
  {
    n: "03",
    title: "Deliver",
    text: "Prepare and deliver the agreed design files and final assets in appropriate formats.",
  },
];

export const MARQUEE = [
  "Graphic Design",
  "Logo Design",
  "Brand Identity",
  "Packaging",
  "Brochures",
  "Website Design",
  "UI Design",
  "Digital Content",
];

export const BUDGETS = ["Under £500", "£500 – £1,500", "£1,500 – £5,000", "£5,000+", "Prefer to discuss"];
